export function openProperty(property) {
  return {
    type: '@property/OPEN_PROPERTY',
    payload: { property },
  };
}
export function openPropertySuccess(property) {
  return {
    type: '@property/OPEN_PROPERTY_SUCCESS',
    payload: { property },
  };
}
